export const overseasConnectionYesNoOptions = [{ value: 'E', name: 'Evet' }, { value: 'H', name: 'Hayır' }]
export const addressTypeOptions = [{ value: '1', name: 'Ev' }, { value: '2', name: 'İş' }]

export const ERROR_CODE_RETAIL_CUSTOMER_NOT_COMMERCIAL = "COR-55553";
export const ERROR_CODE_COR_55552 = "COR-55552";
export const ERROR_CODE_NO_RECORD_FOUND_FOR_YOUR_OPERATION = "COR-50542";
export const ERROR_CODE_GOTO_BRANCH_FOR_POS_APPLICATION = "COR-58391";
